<div class="chart_content">
  <div>
    <app-date-component-renderer [isKpiSalesGraph]="true" [currentDateFilter]="currentDateFilter" ></app-date-component-renderer>
  </div>
  <div class="chart_content-innerbox" *ngIf="mixedChartData">
    <div class="chart_content-stack" *ngIf="!isDashboard">
      <div class="stacks" [ngClass]="{'unchecked' : mixedChartData[i].hidden}" *ngFor="let lLegend of leftLagend; let i = index">
        <mat-checkbox
          (change)="set(i, $event)"
          class="mat-checkbox-sm"
          [checked]="true"
        >
        </mat-checkbox>
        <span class="stacks-color stacks-{{lLegend.name}}"></span>
        {{ lLegend.name }}
      </div>
    </div>
  
    <div class="overflow-auto w-100">
      <div class="chart_content-graph" id="mixedChartID" style="position: relative; height:100%; min-width: 1100px;">
        <app-lines-chart [id]="'mixedChartID'" [yAxisLabelType]="'percentage'" [yAxisLabelType1]="'percentage'" [isKpiLineGraph]="true" [tickInterval]="tickInterval" [isPosition]="true" [data]="mixedChartData" [chartColors]="mixedChartColor" [labels]="mixedChartLabel"></app-lines-chart> 
    </div>
    </div>
  
    <div class="chart_content-stack" *ngIf="!isDashboard">
      <div class="stacks" [ngClass]="{'unchecked' : mixedChartData[j + 5].hidden}" *ngFor="let rLegend of rightLagend; let j = index">
        <mat-checkbox
          (change)="set(j, $event, true)"
          class="mat-checkbox-sm"
          [checked]="true"
        >
        </mat-checkbox>
        <span class="stacks-color stacks-{{rLegend.name}}"></span>
        {{ rLegend.name }}
      </div>
    </div>
  </div>
  <div class="loader" *ngIf="!mixedChartData">
    <img [src]="'assets/images/nineyard-loading.gif'" />
  </div>  
</div>
